import { OnInit, Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  templateUrl: './rawmaterials-values.dialog.html'
})
export class NeqRawmaterialsValuesDialogComponent implements OnInit {

  public message: string;

  constructor(
    private readonly dialogRef: MatDialogRef<NeqRawmaterialsValuesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {message: string}
  ) {
  }

  ngOnInit() {
    this.message = this.data.message;
  }

  process() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
